module.exports = __webpack_public_path__ + "static/media/hourglass.901970b6.svg";